module.exports = __webpack_public_path__ + "img/eg-cn-01.6af1eaf0.png";